import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Policy = () => {
  return (
    <div>
      <div style={{ height: "70px" }} className="herobg">
        <Header />
      </div>
      <div className="container py-2">
        <h3 className="font-medium">WEDEVELOPERS PRIVACY POLICY</h3>
        <p>
          Wedeveloper is committed to upholding the privacy rights of
          individuals. This Privacy Policy explains the collection, use,
          purpose, and sharing of personally identifiable information (“PII”)
          related to the use of Wedevelopers website www.wedeveloper.com,
          wedeveloper’s providing of services to our customers (“Partners”), or
          from our employees. PII does not include information which is
          anonymized or aggregated, and other information which is excluded from
          the scope of applicable privacy laws.
        </p>
        <p>
          Wedeveloper does not require you to register or provide PII to visit
          our website. By accessing our website or purchasing our services, you
          agree to this Privacy Policy in addition to any other agreements we
          might have with you.
        </p>
        <p>
          The information automatically collected by accessing our site is not
          used to track individuals, their browsing, or their access to our
          site. The information is collected and used only for technical
          improvements and statistical analysis of our site. We may, as
          necessary, disclose this information or any other information that may
          identify you to state and local authorities or law enforcement as
          required under law or by court order.
        </p>

        <h5 className="font-normal">Your Choices</h5>
        <p>
          You can use our site without providing any personal identifiable
          information (“PII”). If you choose not to provide any PII, you may not
          be able to use certain services.
        </p>
        <p>
          You may choose to provide us PII, such as your first and last name,
          e-mail and mailing addresses, professional title, and company name
          when you submit a request for information from our website, sign-up
          for or attend our webinars or request other marketing material from
          us, link through our sites to partner sites, or through any links for
          partnership or employment opportunities. If you choose to provide us
          with any PII we will use the information provided to respond to your
          request.
        </p>
        <p>
          If you provide us with your consent to be contacted for marketing
          purposes, you have the right to withdraw your consent at any time by
          following the instructions to “opt-out” of receiving marketing
          communication in each marketing email we send you or by contacting us
          as indicated below.
        </p>
        <p>
          Individuals also have the opportunity to choose (opt out) whether
          their PII is (1) to be disclosed to a third party or (2) to be used
          for a purpose other than the purpose for which it was originally
          collected or subsequently authorized by the individual.{" "}
        </p>
        <p>
          In some instances, we may be required by law to disclose information
          you submit or email to us electronically by law, court order, law
          enforcement request or other purposes to protect our sites or other
          sites due to security threats.
        </p>
        <p>
          Wedevelopers uses industry-standard technologies, administrative,
          technical, and physical measures to protect the security,
          confidentiality and integrity of any information or data collected by
          us.
        </p>
        <p>
          However, no website, service, mobile application, database or system
          is completely secure or “hacker proof.” You are responsible for taking
          reasonable steps to protect your personal information against
          unauthorized disclosure or misuse.
        </p>
        <h5 className="font-normal">Changes to our privacy policy</h5>
        <p>
          Wedevelopers may amend this Privacy Policy at any time by posting a
          new version to our website. It is your responsibility to review this
          Privacy Policy periodically as your continued use of this website and
          our products and services represents your agreement with the
          then-current Privacy Policy.
        </p>
          </div>
          <Footer />
    </div>
  );
};

export default Policy;
